import { Link, useNavigate } from "react-router-dom";
import { MonitorPlay, LogOut, Settings } from "lucide-react";
import { clearAuth, getAuthUsername } from "./ProtectedRoute";

export default function Header({ showManageLink = true }) {
  const navigate = useNavigate();
  const username = getAuthUsername();

  const handleLogout = () => {
    clearAuth();
    navigate("/login", { replace: true });
  };

  return (
    <header className="border-b border-white/10 px-4 py-3 md:px-6 md:py-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <MonitorPlay className="w-6 h-6 text-white group-hover:text-white/80 transition-colors" />
          <span className="font-heading text-xl font-bold text-white uppercase tracking-tighter hidden sm:block">
            Live Channels
          </span>
        </Link>

        <div className="flex items-center gap-4 md:gap-6">
          <span className="text-white/70 text-sm hidden md:block">{username}</span>

          {showManageLink && (
            <Link
              to="/manage"
              data-testid="header-manage-link"
              className="flex items-center gap-1.5 text-white/60 hover:text-white transition-colors text-sm"
            >
              <Settings className="w-4 h-4" />
              <span className="hidden md:inline">Gérer</span>
            </Link>
          )}

          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex items-center gap-1.5 text-white/60 hover:text-red-400 transition-colors text-sm"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden md:inline">Déconnexion</span>
          </button>
        </div>
      </div>
    </header>
  );
}
